export default "__VITE_ASSET__DGEo1qAt__"